<ejs-dialog #assetFilterDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancelFilter()">
  <ng-template #header>
    <div>Filter assets</div>
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col-lg-12 control-section">
        <ejs-querybuilder #querybuilder class="row" [rule]="importRules" [showButtons]="showButtons"
          (ruleChange)="onRuleChange($event)">
          <e-columns>
            <e-column field="ImageQuality"
              label="{{'i18n.domain.assets.asset-storage.edit-asset-storage.image-quality' | translate}}" type="string"
              [operators]="allowedOperatorsEnum">
              <ng-template #template let-data>
                <ejs-dropdownlist [dataSource]="imageQualities" id="imageQuality" [fields]="fields"
                  (change)="filterChange($event, data.ruleID)">
                  <ng-template #itemTemplate let-data>
                    {{data.text | translate}}
                  </ng-template>
                  <ng-template #valueTemplate let-data>
                    <div class="centered">
                      <span>{{data.text | translate}}</span>
                    </div>
                  </ng-template>
                </ejs-dropdownlist>
              </ng-template>
            </e-column>
            <e-column field="License"
              label="{{'i18n.domain.assets.asset-storage.edit-asset-storage.license' | translate}}" type="string"
              [operators]="allowedOperatorsEnum">
              <ng-template #template let-data>
                <ejs-dropdownlist [dataSource]="licenses" id="license" [fields]="fields"
                  (change)="filterChange($event, data.ruleID)">
                  <ng-template #itemTemplate let-data>
                    {{data.text | translate}}
                  </ng-template>
                  <ng-template #valueTemplate let-data>
                    <div class="centered">
                      <span>{{data.text | translate}}</span>
                    </div>
                  </ng-template>
                </ejs-dropdownlist>
              </ng-template>
            </e-column>
            <e-column field="Source"
              label="{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.source' | translate }}" type="string"
              [operators]="allowedOperatorsString">
            </e-column>

            <e-column field="LanguageCodeIso3"
              label="{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.language' | translate }}" type="string"
              [operators]="allowedOperatorsEnum">
              <ng-template #template let-data>
                <ejs-dropdownlist [dataSource]="languages" id="language" (change)="filterChange($event, data.ruleID)">
                </ejs-dropdownlist>
              </ng-template>
            </e-column>

            <e-column field="AssignedKeyWords.AssetStorageKeyWord.Name" label="{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.keyword' | translate }}" type="string" [operators]="allowedOperatorsString"></e-column>
          </e-columns>

        </ejs-querybuilder>
      </div>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <div class="d-flex">
        <div class="btn-group me-auto">
          <button type="button" (click)="clearFilter()" class="btn btn-outline-danger me-2 btn-fixedw rounded"
            [disabled]="!(qryBldrObj?.rule?.rules?.length > 0)">
            <span class="e-icons icon-erase danger me-2"></span>
            {{ 'i18n.domain.assets.asset-storage.edit-asset-storage.clear-filter-button' | translate }}
          </button>
        </div>
        <div class="btn-group ms-auto">
          <button class="e-control e-btn e-lib e-flat" (click)="onCancelFilter()">
            {{'i18n.shared.cancel' | translate}}
          </button>
          <button class="e-control e-btn e-lib e-primary e-flat" (click)="onApplyFilter()"
            [disabled]="!(qryBldrObj?.rule?.rules?.length > 0)">
            {{'i18n.domain.assets.asset-storage.edit-asset-storage.apply-filter-button' | translate}}
          </button>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ejs-dialog>
